<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <el-row v-for="(checklist, index) in checklistData" :key="index" class="checklist-wrapper" :gutter="20">
      <el-col :span="16">
        <el-col :span="24">
          <div>
            <table class="hiaTable">
              <thead>
                <tr>
                  <th>Checklist</th>
                  <th style="padding-right: 13px;">Records</th>
                  <th style="padding-right: 13px;">All Criteria Met</th>
                  <th style="padding-right: 13px;">Accuracy</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="textAlignLeft">{{ checklist.checklistName }}</td>
                  <td class="textAlignRight">{{ checklist.totalRecords }}</td>
                  <td class="textAlignRight">{{ checklist.allCriteriaMet }}</td>
                  <td class="textAlignRight">{{ formatPercentage(checklist.accuracy) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-col>

        <el-col :span="24">
          <div style="margin-left: 20px; margin-top: 20px;">
            <table class="hiaTable" style="margin-top: 20px;">
              <thead>
                <tr>
                  <th style="width: 40%"> Question </th>
                  <th> Yes </th>
                  <th> No </th>
                  <th> N/A </th>
                  <th> Not Answered </th>
                </tr>
              </thead>
              <tr v-for="(item, index) in checklist.checklistSummary" :key="index">
                <td class="textAlignLeft" style="width: 40%"> {{item.question}} </td>
                <td> {{item.yes}} </td>
                <td> {{item.no}} </td>
                <td> {{item.na}} </td>
                <td> {{item.notAnswered}} </td>
              </tr>
              <tr class="strong emphasis">
                <td class="textAlignLeft">Total</td>
                <td>{{getSummaries(checklist.checklistSummary)[1]}}</td>
                <td>{{getSummaries(checklist.checklistSummary)[2]}}</td>
                <td>{{getSummaries(checklist.checklistSummary)[3]}}</td>
                <td>{{getSummaries(checklist.checklistSummary)[4]}}</td>
              </tr>
            </table>
          </div>

        </el-col>
      </el-col>

      <el-col :span="8" style="text-align: center; margin-top: 28px;">
        <ChecklistBarChart :chartId="`IP_Printable_barchart${checklist.checklistId}${checklist.codeDesc}`" :checklistName="checklist.checklistName"
          :checklistData="checklist.checklistSummary" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'
  import csvGenerator from '@/mixins/csvGenerator'
  import dateHelper from '@/mixins/date-helper'
  import ChecklistBarChart from '@/views/reports/highcharts/checklistBarChart.vue'

  export default {
    name: 'IP_FindingSummaryCPT',
    mixins: [hiaFilters, money, dashboardHelper, csvGenerator, dateHelper],
    props: ['drgTableIds', 'codeTypes'],
    data: function () {
      return {
        checklistData: [],
        checklistTotals: {},
        filterCriteria: '',
        loading: false,
        loadingAccounts: false,
        dialogVisible: false,
        summaryDialogVisible: false,
        subProRecordIds: null,
        summaryRow: {},
        detailsHeader: '',
        accountDetails: []
      }
    },
    methods: {
      async getData() {
        const payload = {
          drgTableIds: this.drgTableIds,
          codeTypes: this.codeTypes,
          includeAccts: true,
          statType: 'test'
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/dashboard/ipChecklistSummary`, payload)
          this.checklistData = response.data
        } catch (err) {
          this.checklistData = []
        } finally {
          this.loading = false
        }
      },
      getSummaries(data) {
        const param = {
          columns: [
            { property: 'question' },
            { property: 'yes' },
            { property: 'no' },
            { property: 'na' },
            { property: 'notAnswered' }
          ],
          data: data
        }
        return this.getSummary(param)
      },
      cellClasses({ row, column, rowIndex, columnIndex }) {
        if (column.property === 'question') {
          return 'textAlignLeft'
        }
        if (column.property === 'details') {
          return 'textAlignCenter'
        }
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      ...mapState('reports/', ['ipReportDataLoading'])
    },
    components: {
      ChecklistBarChart
    },
    mounted: async function () {
      await this.getData()
    },
    activated: async function () {
      await this.getData()
    },
    watch: {
      drgTableIds: async function () {
        await this.getData()
      },
      codeTypes: async function () {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
  .hiddenVisibility {
    visibility: hidden;
  }

  .totalsTable {
    border-spacing: 0px;
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }

  .totalsTable td {
    padding: 13px;
  }

  .checklist-wrapper:not(:first-child) {
    margin-top: 30px !important;
  }

  .codetype-wrapper:not(:first-child) {
    margin-top: 60px !important;
  }

  .totalsTable th:not(:first-child),
  .totalsTable td:not(:first-child) {
    text-align: right;
    margin-right: 5px;
  }

  .subTable th:not(:first-child),
  .subTable td:not(:first-child) {
    text-align: right;
    margin-right: 5px;
  }
</style>
